export default __webpack_public_path__ + "static/main_service_image-bd54a74a6239d553bae042b56cf735a0.svg";